import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import GalleryGrid from '../components/GalleryGrid';

export default function DocumentationCE() {
  const galleryImages = [
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/8a3e6d-38f93c76eb184f888d48b892497ae3dc.jpg',
    'https://assets.auxodev.dk/assets/1cab479d-9d2b-49e7-a4f6-be9602b123ca/elkonstruktion-styretavle.jpg',
  ];

  return (
    <div className="bg-[#0b1017] text-slate-100 min-h-screen">
      <SEO
        title="Dokumentation og CE mærkning - JARCon ApS"
        description="Udfærdige mekanisk og elektrisk dokumentation (PC Schematik) på Dansk, Tysk og Engelsk. CE mærkning."
      />

      <PageHeader
        badge="Konsulentydelser"
        title="Dokumentation og CE mærkning"
        subtitle="Mekanisk og elektrisk dokumentation (PC Schematik) på Dansk, Tysk og Engelsk • CE mærkning"
        breadcrumbs={[
          { label: 'Konsulentydelser', path: '/konsulentydelser' },
          { label: 'Dokumentation og CE mærkning' },
        ]}
        ctaText="Hør om CE dokumentation"
        ctaLink="/kontakt"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8 space-y-8">
            <div className="p-8 rounded-xl bg-[#0e1622] border border-slate-800 space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-widest font-semibold block">
                Lovkrav &amp; Standarder
              </span>
              <h2 className="font-display text-2xl font-bold text-white">
                Dokumentation og CE mærkning
              </h2>
              <p className="text-slate-300 text-base leading-relaxed">
                Udfærdige mekanisk og elektrisk dokumentation (PC Schematik) på Dansk, Tysk og Engelsk. CE mærkning.
              </p>
              <p className="text-slate-400 text-sm leading-relaxed">
                Korrekt teknisk dokumentation er et krav ifølge Maskindirektivet og en væsentlig forudsætning for fremtidig vedligeholdelse, fejlfinding og reservedelsbestilling. JARCon sikrer, at alle diagrammer, manualer og risikovurderinger lever op til gældende standarder.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800 space-y-3">
                <div className="w-10 h-10 rounded-lg bg-cyan-950/70 border border-cyan-500/30 text-cyan-400 flex items-center justify-center text-lg">
                  <i className="fa-solid fa-file-lines" aria-hidden="true" />
                </div>
                <h3 className="font-display font-bold text-lg text-white">PC Schematik</h3>
                <p className="text-xs text-slate-400 leading-relaxed">
                  Udarbejdelse af komplette elektriske diagrammer, klemrækker, kabellister og styklister i PC Schematik.
                </p>
              </div>

              <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800 space-y-3">
                <div className="w-10 h-10 rounded-lg bg-cyan-950/70 border border-cyan-500/30 text-cyan-400 flex items-center justify-center text-lg">
                  <i className="fa-solid fa-shield-halved" aria-hidden="true" />
                </div>
                <h3 className="font-display font-bold text-lg text-white">CE Mærkning</h3>
                <p className="text-xs text-slate-400 leading-relaxed">
                  Risikovurdering, sikkerhedsdokumentation og overensstemmelseserklæring iht. Maskindirektivet og EN standarder.
                </p>
              </div>
            </div>

            <GalleryGrid
              title="Dokumentation og eldiagrammer galleri"
              subtitle="Klik for at se billeder i fuld opløsning"
              images={galleryImages}
            />
          </div>

          <div className="lg:col-span-4 space-y-6">
            <div className="p-6 rounded-xl bg-[#0e1622] border border-slate-800">
              <h3 className="font-display text-base font-bold text-white mb-4">
                Sprog og omfang
              </h3>
              <ul className="space-y-3 text-xs font-open-sans text-slate-300">
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Dansk sprogpakke</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Tysk sprogpakke</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Engelsk sprogpakke</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>Mekanisk og elektrisk dokumentation</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="fa-solid fa-check text-cyan-400" aria-hidden="true" />
                  <span>CE mærkning</span>
                </li>
              </ul>
            </div>

            <div className="p-6 rounded-xl bg-gradient-to-br from-[#0e1622] to-[#070b10] border border-cyan-500/40 text-center space-y-4">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-wider block font-semibold">
                Behov for CE mærkning?
              </span>
              <p className="text-xs text-slate-300">
                Få professionel hjælp til udarbejdelse af tekniske dossierer og diagrammer.
              </p>
              <Link
                to="/kontakt"
                className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-cyan-500 hover:bg-cyan-600 text-white font-bold text-xs uppercase tracking-wider transition-all"
              >
                <span>Kontakt os</span>
                <i className="fa-solid fa-arrow-right" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
